package com.starparty.app.astro0.renderers

import com.starparty.app.astro0.SP_Canvas
import com.starparty.app.astro0.SP_Colour
import com.starparty.app.astro0.SP_Paint
import com.starparty.app.astro0.Sky
import com.starparty.app.astro0.celestialobjects.CelestialBody
import com.starparty.app.astro0.js.SP_JSPaint
import com.starparty.app.geometry.SP_Rectangle

/**
 * Title:        Starparty Astro-0
 * Description:  Simply astronomy package for starparty.com and sennen-cove-cornwall.uk
 * Copyright:    Copyright (c) 2021
 * Company: starparty.com
 * @author Rob Leeson
 * @version 2.0
 */
abstract class CelestialBodyRenderer {

    val labelDistance = 5


    /** draws the b as a filled circle or rectangle below 1 pixel radius */
    open fun paint(b: CelestialBody, labelType:Int, g: SP_Canvas, theme: RendererTheme) {

        val d = getDiameter(b)
        val r = (d / 2.0)
        // int halfDiam = (int) Math.round(((float) diameter) / 2.0);
        val x = b.skyLocation.x
        val y = b.skyLocation.y
        val left = x - r
        val top = y - r

        theme.setCelestialBodyColour(b)
        val p = theme.celestialBodyPaint

        if (r <= 1) {
            val rect = SP_Rectangle(left, top, d, d)
            g.drawRectFilled(rect, p)
        } else {
            paintDetailedCelestialBody(b, r, left, top, x, y, p, theme, g)
        }

        paintTitle(b, d, labelType, g, theme)
    }

    open fun paintDetailedCelestialBody(b: CelestialBody,
                                        radius: Double,
                                        left:Double,
                                        top:Double,
                                        x:Double,
                                        y:Double,
                                        p: SP_Paint,
                                        theme: RendererTheme,
                                        g:SP_Canvas) {

        g.drawCircleFilled(x, y, radius, p)
    }

   open fun paintTitle(b: CelestialBody, diameter: Double,
                   labelType: Int, g: SP_Canvas, rendererTheme: RendererTheme){
        val loc = b.skyLocation
        val x = loc.x + (diameter / 2.0) + labelDistance
        val y = loc.y + (diameter / 3.0)

        var name: String = getTitle(b, labelType)

        if (name === ""){
            return
        }

        var p = rendererTheme.celestialBodyPaint
        var fontSize = getLabelFontSize(labelType, rendererTheme)
        p.setTextSize(fontSize)

        val boundsResult = p.getTextBounds(name)

        val pt = b.skyLocation

        val textHeight = boundsResult.height
        val textWidth = boundsResult.width

        g.drawText(name, x, y, p)

    }


    open fun getLabelFontSize(labelType: Int, rendererTheme: RendererTheme): Float {

        var fontSize: Float = rendererTheme.celestialBodyFullLabelFontSize
        if (labelType == Sky.ABBR_TITLES) {
            fontSize = rendererTheme.celestialBodyAbbrevLabelFontSize
        }

        return fontSize
    }

    fun getTitle(b:CelestialBody, labelType: Int): String {
        var name = ""

        when (labelType) {
            Sky.FULL_TITLES -> name = b.name
            Sky.ABBR_TITLES -> name = b.abbrevName
        }

        return name
    }



    abstract protected fun getDiameter(b: CelestialBody): Double

    abstract protected fun getColour(c: CelestialBody): SP_Colour
}